import {api} from '../helpers/api';
import utils from '../helpers/utils';

export const ACC_SER_SERVICECODE_KEYVALUES_GET_REQUEST = 'ACC_SER_SERVICECODE_KEYVALUES_GET_REQUEST';
export const ACC_SER_SERVICECODE_KEYVALUES_GET_SUCCESS = 'ACC_SER_SERVICECODE_KEYVALUES_GET_SUCCESS';
export const ACC_SER_SERVICECODE_KEYVALUES_GET_FAILURE = 'ACC_SER_SERVICECODE_KEYVALUES_GET_FAILURE';
export const ACC_SER_SERVICECODE_KEYVALUES_UPDATE_REQUEST = 'ACC_SER_SERVICECODE_KEYVALUES_UPDATE_REQUEST';
export const ACC_SER_SERVICECODE_KEYVALUES_UPDATE_SUCCESS = 'ACC_SER_SERVICECODE_KEYVALUES_UPDATE_SUCCESS';
export const ACC_SER_SERVICECODE_KEYVALUES_UPDATE_FAILURE = 'ACC_SER_SERVICECODE_KEYVALUES_UPDATE_FAILURE';

export const accSerServiceCodeKeyValuesGetRequest = () => ({
  type: ACC_SER_SERVICECODE_KEYVALUES_GET_REQUEST,
});

export const accSerServiceCodeKeyValuesGetSuccess = (data: $TSFixMe) => ({
  type: ACC_SER_SERVICECODE_KEYVALUES_GET_SUCCESS,
  data,
});

export const accSerServiceCodeKeyValuesGetFailure = () => ({
  type: ACC_SER_SERVICECODE_KEYVALUES_GET_FAILURE,
});

export const accSerServiceCodeKeyValuesUpdateRequest = () => ({
  type: ACC_SER_SERVICECODE_KEYVALUES_UPDATE_REQUEST,
});

export const accSerServiceCodeKeyValuesUpdateSuccess = (data: $TSFixMe) => ({
  type: ACC_SER_SERVICECODE_KEYVALUES_UPDATE_SUCCESS,
  data,
});

export const accSerServiceCodeKeyValuesUpdateFailure = () => ({
  type: ACC_SER_SERVICECODE_KEYVALUES_UPDATE_FAILURE,
});

export const getAccSerServiceCodeKeyValues = (serviceCode: $TSFixMe) => {
  const url = utils.getAccSerServiceCodeKeyValuesPath() + `/${serviceCode}`;
  const config: FetchConfig = {
    method: 'GET',
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json',
      'X-CSRF-Token': utils.getCookieValue(document.cookie, 'XSRF-TOKEN'),
    },
    credentials: 'include',
  };

  return api(
    url,
    config,
    accSerServiceCodeKeyValuesGetRequest(),
    accSerServiceCodeKeyValuesGetSuccess,
    accSerServiceCodeKeyValuesGetFailure
  );
};

export const updateAccSerServiceCodeKeyValues = (keyValues: $TSFixMe) => {
  const url = utils.getAccSerServiceCodeKeyValuesPath();
  const config: FetchConfig = {
    method: 'PUT',
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json',
      'X-CSRF-Token': utils.getCookieValue(document.cookie, 'XSRF-TOKEN'),
    },
    body: JSON.stringify(keyValues),
    credentials: 'include',
  };
  return api(
    url,
    config,
    accSerServiceCodeKeyValuesUpdateRequest(),
    accSerServiceCodeKeyValuesUpdateSuccess,
    accSerServiceCodeKeyValuesUpdateFailure
  );
};
